// VehAllocBbsInput.js
import React, { useEffect, useState } from 'react';
import { Box } from '@mui/system';
// import { styled } from '@mui/material/styles';
import { Button, DialogContent, DialogActions, CircularProgress } from '@mui/material';
import LocalShippingIcon from '@mui/icons-material/LocalShipping';
import { AppStyle, AppWord, AppObject } from '../../../value/AppConst';
import { BbsInfoDict } from '../BbsInfoDict';
import { useConfirmDialog } from '../../../common/AppConfirmDialog';
import VzmTextField from '../../../common/VzmTextField';
import VzmTextareaField from '../../../common/VzmTextareaField';
import VzmDateField from '../../../common/VzmDateField';
import { VzmInputBlock } from '../../../common/VzmStyled';
import InputUtil from '../../../value/InputUtil';
import ValueMisc from '../../../value/ValueMisc';
import { useReactiveVar } from '@apollo/client';
import { userInfoRepo } from '../../../value/AppModel';
import DraggableEditor from '../../../common/DraggableEditor';
import BbsFiles from '../BbsFiles';

const InputMap = BbsInfoDict.inputMap;
const defaultInputData = InputUtil.defaultValuesFromInputMap(InputMap);

/**
 * 배차현황 게시판 입력 화면
 * @param {*} param0 
 * @returns 
 */
export default function VehAllocBbsInput({
    open,
    item,
    onClose,
    onRequestSave,
    responseSaving, // Response if result is NOT OK.
    onRequestReload
}) {
    const [input, setInput] = useState({...AppObject.emptyInputData});
    const [isEdit, setIsEdit] = useState(false);
    const openConfirmDialog = useConfirmDialog();
    const sessionInfo = useReactiveVar(userInfoRepo);
    const {loading:loadingSave, error:errorSave, data:resultSave} = responseSaving; // 전송 결과에 대한 View 기능 소화.

    useEffect(()=>{
        if(open) {
            const inputSet = {...AppObject.emptyInputData};
            let editing = false;
            if(item) {
                inputSet.data = {...item};
                editing = true;
            }
            else {
                inputSet.data = {...defaultInputData};
                inputSet.data.dcCd = sessionInfo.user.dscIdAs;
                inputSet.data.bbsTypeCd = BbsInfoDict.bbcType.VehAlloc.code; // 게시판 종류 지정.(배차현황))
                inputSet.data.announceDate = ValueMisc.getYMD();
            }
            setInput(inputSet);
            setIsEdit(editing);
        }
    }, [open, item, sessionInfo]);

    const onChangeValue = (id, value, error) => {
        const newInput = InputUtil.reflectData(input, id, value, error, InputMap, isEdit);
        setInput(newInput);
    };

    const onClickSubmit = () => {
        const param = InputUtil.getDataToSubmit(input.data, InputMap, isEdit);
        onRequestSave(param, isEdit);
    };

    const askCancel = async () => {
        const confirm = await openConfirmDialog({
            ...AppObject.messageCancelEdit,
            option: {yesLabel: AppWord.IgnoreAndClose}
        });
        if(confirm) onClose();
    };

    const onClickCancel = () => {
        if(input.changed) askCancel();
        else onClose();
    };

    return(
        <DraggableEditor open={open} maxWidth='lg'
            startIcon={<LocalShippingIcon fontSize={AppWord.LARGE} />}
            title={isEdit ? '배차현황 수정' : '배차현황 등록'}
        >
            <DialogContent>
                <VzmInputBlock style={{minWidth: 600}}>
                    <VzmTextField
                        dict={InputMap.title}
                        value={input.data.title}
                        onChange={onChangeValue}
                        fullWidth={true}
                    />
                </VzmInputBlock>
                <Box style={{display: 'flex', gap: 20}}>
                    <VzmInputBlock style={{flexGrow:1}}>
                        <VzmTextField
                            dict={InputMap.email}
                            value={input.data.email}
                            onChange={onChangeValue}
                            fullWidth={true}
                        />
                    </VzmInputBlock>
                    <VzmInputBlock>
                        <VzmDateField
                            dict={InputMap.announceDate}
                            value={input.data.announceDate}
                            error={input.error.announceDate}
                            onChange={onChangeValue}
                        />
                    </VzmInputBlock>
                </Box>
                <VzmInputBlock>
                    <VzmTextareaField
                        dict={InputMap.content}
                        value={input.data.content}
                        onChange={onChangeValue}
                        fullWidth={true}
                    />
                </VzmInputBlock>
                {
                    isEdit &&
                    <BbsFiles
                        item={item}
                        actionDisabled={input.changed}
                        onRequestReload={onRequestReload}
                    />
                }
            </DialogContent>
            <DialogActions>
                {
                    loadingSave
                    ?
                    <span>
                        <CircularProgress />
                        &nbsp;데이터 저장 중...
                    </span>
                    :
                    <>
                        <Button
                            onClick={onClickSubmit}
                            disabled={input.hasError || !input.changed}
                            variant={AppStyle.mui.contained}
                            color={AppStyle.mui.primary}
                        >저장</Button>
                        <Button onClick={onClickCancel}
                            color={AppStyle.mui.warning}
                            variant={AppStyle.mui.contained}
                        >취소</Button>
                    </>
                }
            </DialogActions>
        </DraggableEditor>
    );
}
